// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__2PqJa","tag":"styles_tag__14kMS","goldStar":"styles_goldStar__2wEkC"};